interface PaymentMethodApiError {
  response?: {
    data?: {
      code?: unknown;
    };
  };
}

export const getPaymentMethodErrorCode = (error: unknown): string => {
  if (!error || typeof error !== "object") {
    return "PAYMENT_METHOD_UPDATE_FAILED";
  }

  const code = (error as PaymentMethodApiError).response?.data?.code;
  return typeof code === "string" ? code : "PAYMENT_METHOD_UPDATE_FAILED";
};
